var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrashIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.167 2.333H8v-.5C8 1.19 7.477.667 6.833.667H5.168C4.524.667 4 1.19 4 1.833v.5H1.833a.5.5 0 0 0 0 1h8.334a.5.5 0 0 0 0-1ZM5 1.833c0-.092.075-.166.167-.166h1.667c.092 0 .166.074.166.166v.5H5v-.5ZM9 4H3a.498.498 0 0 0-.5.527l.267 5.069a1.833 1.833 0 0 0 1.831 1.737h2.803c.976 0 1.78-.763 1.831-1.736l.267-5.07a.5.5 0 0 0-.5-.527H9Z"
}))));
export default SvgTrashIcon;